export default __webpack_public_path__ + "static/media/letter_gray.c1196411.svg";